import React from 'react';
import StatCard from './StatCard';

/**
 * Shared KPI row — renders an array of stat definitions as StatCards.
 *
 * Each dashboard builds its own `stats` array and passes it in, e.g.
 *
 *   const stats = [
 *     { label: 'Total Employees', value: total, sub: 'All staff', icon: Users, tone: 'primary' },
 *     { label: 'Active Employees', value: active, sub: `${pct}%`, icon: UserCheck, tone: 'emerald' },
 *   ];
 *   <StatGrid stats={stats} columns={6} />
 *
 * @param {Array}   stats     Array of StatCard prop objects
 * @param {number}  [columns] Cards per row on large screens: 3, 4, 6 or 8
 * @param {string}  [className]
 */

// Full class strings only — Tailwind's JIT can't see dynamically built names.
const COLS = {
  3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4',
  6: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6',
  8: 'grid-cols-2 sm:grid-cols-4 lg:grid-cols-8',
};

export default function StatGrid({ stats = [], columns = 6, className = '' }) {
  const cols = COLS[columns] || COLS[6];

  return (
    <div className={`grid ${cols} gap-4 ${className}`}>
      {stats.map((stat) => (
        <StatCard key={stat.label} {...stat} />
      ))}
    </div>
  );
}
